import React, { useState, useEffect, Fragment } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  FormGroup
} from "reactstrap";
import FieldWrapper from "../commons/FieldWrapper";
import { saveProfileCustomQuestion } from "./Axios";

const ProfileCustomQuestionForm = ({
                                     bgColor,
                                     buttonText,
                                     showNotification,
                                     addQuestion,
                                     question,
                                     updateHit,
                                     size
                                   }) => {
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [answerType, setAnswerType] = useState("text");
  const [required, setRequired] = useState(question?.required || false);
  const [errors, setErrors] = useState({ nameErrors: [] });

  useEffect(() => {
    if (question) {
      setName(question.name);
      setAnswerType(question.answer_type || "text");
    }
  }, [question]);

  const toggle = () => setModal(!modal);

  const saveErrors = (errors) => {
    setErrors({ nameErrors: errors.name });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("profile_custom_question[name]", name);
    formData.append("profile_custom_question[answer_type]", answerType);
    formData.append("profile_custom_question[required]", required);

    saveProfileCustomQuestion(question, formData, (response) => {
      if (response.status === 201) {
        showNotification("Genial", "Pregunta guardada con éxito!", "success");
        toggle();
        setName("");
        setAnswerType("text");
        setErrors({ nameErrors: [] });
        addQuestion(response.data);
      } else if (response.status === 200) {
        showNotification("Genial", "Pregunta actualizada con éxito!", "success");
        toggle();
        updateHit(response.data);
      } else if (response.status === 422) {
        saveErrors(response.data);
        showNotification("Ops", "Hubo un error, revisa el formulario!", "danger");
      }
    });
  };

  return (
    <Fragment>
      <Button color={bgColor} onClick={toggle} size={size} style={{ color: "white" }}>
        {buttonText}
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>
          {buttonText} Pregunta de Perfil
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="name" className="input_required">Pregunta</Label>
            <FieldWrapper errors={errors.nameErrors}>
              <Input
                id="name"
                type="textarea"
                placeholder="Escribe la pregunta aquí"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </FieldWrapper>
          </FormGroup>
          <FormGroup>
            <Label for="answerType" className="input_required">Tipo de Respuesta</Label>
            <Input
              id="answerType"
              type="select"
              value={answerType}
              onChange={e => setAnswerType(e.target.value)}
            >
              <option value="text">Texto</option>
              <option value="textarea">Area Texto</option>
              <option value="number">Número</option>
              <option value="boolean">Sí / No</option>
            </Input>
          </FormGroup>
          <FormGroup check className="mb-2">
            <Label check>
              <Input
                type="checkbox"
                checked={required}
                onChange={() => setRequired(!required)}
              />{" "}
              Obligatoria
            </Label>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmit}>Guardar</Button>
          <Button color="danger" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default ProfileCustomQuestionForm;